// extracted by mini-css-extract-plugin
export default {"buttonText":"auth__buttonText__YkDdbp","regular":"auth__regular__Ltntju","medium":"auth__medium__YXesnX","underlined":"auth__underlined__RBsfup","muted":"auth__muted__Vo8nzA"};